import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../utils/hooks/useAxios";
import { filterObject } from "@/utils/helpers";

/**
 * GET makkah/pilgrim-visa-groups — paginated visa summary by mission / nationality / country.
 * Query params: query, page, mission_id, nationality_id, country_id, visa_status (active | inactive).
 */
export const useGetPilgrimVisaGroupsQuery = (params = {}) => {
  const { axiosProtected } = useAxios();
  const filtered = filterObject({
    ...params,
    query: params.query?.trim() ? params.query.trim() : undefined,
  });

  const queryParams = new URLSearchParams();
  Object.keys(filtered).forEach((key) => {
    const v = filtered[key];
    if (v !== undefined && v !== null && v !== "") {
      queryParams.append(key, v);
    }
  });

  const queryString = queryParams.toString();
  const url = queryString
    ? `makkah/pilgrim-visa-groups?${queryString}`
    : "makkah/pilgrim-visa-groups";

  return useQuery({
    queryKey: ["pilgrim-visa-groups", filtered],
    queryFn: () => axiosProtected.get(url),
  });
};
